var factory = require('./factories/iframe_next_gen_container_factory');

factory.getFrameContainer('write').showWidget();



/*****************
 ** WEBPACK FOOTER
 ** ./client/iframe_container_next_gen_write.js
 ** module id = 0
 ** module chunks = 0
 **/